import { z } from 'zod';
import { createFiltersAtom } from './createFiltersAtom';

export const emptyFilterAtom = createFiltersAtom<object>({
  defaultFilters: {},
  filtersSchema: z.object({}),
});
